export default "__VITE_ASSET__BeVX2OlM__"